import {_, React, observer, observable, computed, action, useLocalStore, classNames, Fragment, Popover2} from '@api'
import { HorzAlign, VerticalAlign} from '@stores/catalog'
import {FlexLayoutMaximizedToolbarItems, FlexLayoutReportNavigator, useCatalogRootFlexLayoutStore} from '@stores/catalog/flexLayout'
import {DebugFooterButtons} from './DebugFooterButtons'
import { useCatalog} from '@stores'
import {AssortmentCardSizeSliderCatalog, AssortmentCatalogSwatchGlobalChooser, AssortmentClearCardSettingsGlobal, CardSizePercentageLabel, CardSizeSliderCatalog, CardSpacingSliderCatalog, CatalogColumnSliderMaterial, ColumnViewCatalogModeToggleButton, HeroCardsToolbarButton, ImageSourceToolbarButton, StackedCardSpreadSlider, ToggleAssortmentColumnViewButton, ToggleCardSwatchesButton, ToggleFlatModeToolbarButton} from '@modules'
import * as css from './CatalogFooter.css'
import { PrimaryIconButton } from 'centric-ui-components'
import {Icon, IconName, Menu, MenuDivider, MenuItem} from '@blueprintjs/core'

/// region Components

interface MyProps {
  className?: string
}

export const CatalogFooter = observer<MyProps>(function CatalogFooter({className, ...props}) {
  const catalog = useCatalog(),
    {currentUser: {userSettings: {focusMode}, anyFocusModeItemsExplicitlyChecked}, flexLayout: {flexEnabled, isMaximized}, groupBy: {isGroupedView}, settings: {imageSource, viewMode, pdf: {}, toolbarItems: {sliders}}, footer: {visible}} = catalog,
    flexCatalog = useCatalogRootFlexLayoutStore()

  if (!flexEnabled && viewMode === 'table') return null

  if (focusMode.enabled && (focusMode.footers || !anyFocusModeItemsExplicitlyChecked)) return null

  // Don't show the footer when in a tab modal
  if (flexEnabled && isMaximized && flexCatalog) {
    const {catalog: {sidebar: {right: {open, isModal}}}} = flexCatalog
    if (isModal && open) return null
  }

  const {assortments} = catalog
  // console.log(catalog, {isGlobalStore: catalog.isGlobalStore})
  return (
    <div className={classNames(css.root, className)}
         data-fade-animation='false'
         data-visible={visible}>

      <div className={css.left}>
        {false && DEBUG && <DebugFooterButtons />}
        {false && (isMaximized || catalog.isGlobalStore) && <Fragment>
	        <FlexLayoutReportNavigator/>
	        <FlexLayoutMaximizedToolbarItems className={css.maximizeBar}/>
        </Fragment>}
        {imageSource?.toolbar?.location === 'footer' &&
         (!assortments?.selectedAssortment || !assortments.isCollapsedAll) &&
         <ImageSourceToolbarButton/>}
      </div>

      {catalog.assortments?.selectedAssortment && <Fragment>
          <AssortmentClearCardSettingsGlobal />
          <AssortmentCatalogSwatchGlobalChooser />
      </Fragment>}
      {catalog.isShowingClientPDF !== true && <div className={css.viewButtons}>
          <CatalogHorizontalAlignmentDropdownButton/>
          <CatalogVerticalAlignmentDropdownButton/>
      </div>}
      {isGroupedView && <div className={css.viewButtons}>
        <ColumnViewCatalogModeToggleButton tooltipPlacement='top'/>
        <ToggleFlatModeToolbarButton tooltipPlacement='top'/>
	      <div className={css.divider}/>
        {/*{DEBUG && <HeroCardsToolbarButton tooltipPlacement='top' />}*/}
        <ToggleCardSwatchesButton tooltipPlacement='top'/>
      </div>}

      {sliders.visible && sliders.location === 'footer' ?
	   <div className={css.sliders}>
       {assortments?.selectedAssortment && <Fragment>
  		   <AssortmentCardSizeSliderCatalog/>
	       {/*<ToggleAssortmentColumnViewButton/>*/}
       </Fragment>}
       <CatalogColumnSliderMaterial/>
       {(!catalog.isShowingAssortment || !catalog.groupBy.isCollapsedAll) && catalog.isShowingClientPDF !== true &&
        <Popover2
        interactionKind='hover'
        placement='top-end'
        content={<Menu>
          <div className={css.slidersMenuItems}>
          <StackedCardSpreadSlider tooltipLocation='top'/>
          {/*<ImageSourceGridSliders />*/}
          {/*<StackedCardScaleSlider className={styles.slider}/>*/}
          <CardSpacingSliderCatalog/>
          <CardSizeSliderCatalog/>
          </div>
        </Menu>}
        >
            <CardSizePercentageLabel className={css.percentageLabel}/>
        </Popover2>}
     </div>
      : <Fragment>
       </Fragment>}
    </div>)
})

/// endregion

export const CatalogHorizontalAlignmentDropdownButton = observer(function CatalogHorizontalAlignmentDropdownButton() {
    const catalog = useCatalog()

  if (!catalog || catalog.stores.purpose === 'inline-details' || catalog.stores.purpose === 'library-filters') return null

  const {settings, settings: {align}} = catalog

    return (
      <Popover2
        interactionKind='hover'
        content={<Menu>
          <MenuDivider title='Card Alignment' />
          {['left', 'center', 'right'].map((v: HorzAlign) => (
          <MenuItem key={v}
                    shouldDismissPopover={false}
                    labelElement={<Icon icon={`align-${v}`} />}
                    icon={v === align ? 'tick' : 'blank'}
                    text={_.capitalize(v)}
                    onClick={() => settings.align = v} active={align === v}/>
                                                                ))}
        </Menu>}
      >
        <PrimaryIconButton icon={`align-${align}`} />
      </Popover2>)
})

export const CatalogVerticalAlignmentDropdownButton = observer(function CatalogVerticalAlignmentDropdownButton() {
  const catalog = useCatalog()

  if (!catalog || catalog.stores.purpose === 'inline-details' || catalog.stores.purpose === 'library-filters') return null

  const {settings, settings: {verticalAlign}} = catalog,
    iconFor = (v : VerticalAlign) : IconName => {
    return v === 'top' ? 'alignment-top' : v === 'center' ? 'alignment-vertical-center' : 'alignment-bottom'
  }

  return (
    <Popover2
      interactionKind='hover'
      content={<Menu>
        <MenuDivider title='Card Alignment'/>
        {['top', 'center', 'bottom'].map((v: VerticalAlign) => (
          <MenuItem key={v}
                    shouldDismissPopover={false}
                    labelElement={<Icon icon={iconFor(v)}/>}
                    icon={v === verticalAlign ? 'tick' : 'blank'}
                    text={_.capitalize(v)}
                    onClick={() => settings.verticalAlign = v}
                    active={verticalAlign === v}/>
        ))}
      </Menu>}
    >
      <PrimaryIconButton icon={iconFor(verticalAlign)}/>
    </Popover2>)
})



// WEBPACK FOOTER //
// ./src/modules/catalog/CatalogFooter/CatalogFooter.tsx